<template>
    <div>
        <h1 class="view-title" data-v-step-distribution-center="1">
			CENTROS DE DISTRIBUÇÃO <span v-popover:tooltip.right="'Seção de gerenciamento dos Centros de Distribuição'"><i class="fas fa-question-circle"></i></span>
		</h1>
        
        <div class="inner-content shadowed">
            <div class="inner-content-title">
				Lista <span v-popover:tooltip.right="'Lista dos centros cadastrados'"><i class="fas fa-question-circle"></i></span>
				<button class="add_new_origin" @click="create()" data-v-step-distribution-center="3" :disabled="!$permission.hasAreaEditPermission('DistributionCenter')">
					<i class="fa fa-plus"></i> ADICIONAR
				</button>
                <button class="btn btn-link btn-right" @click="$refs.tour.editTour()" style="margin-top: 10px; margin-left: 15px;" data-v-step-distribution-center="2">
                    <i class="fas fa-question-circle"></i> TOUR
                </button>
			</div>
            
            <div class="row">
				<div class="col-xs-12 col-lg-12">
                    <div class="search" data-v-step-distribution-center="4">
                        <label>Filtro <span v-popover:tooltip.right="'Informe uma palavra-chave para identificação do registro desejado'"><i class="fas fa-question-circle"></i></span>:</label>
                        <input type="text" v-model="search" @keydown.enter.prevent="load(true)" /> 
                    </div>
                    <Table 
                    :loading="loading"
                    :headers="headers" 
                    :ordering="ordering"
                    :order="order"
                    @reorder="(o) => { order = o; load(); }"
                    :list="list" 
                    :page="page"
                    :per_page="per_page" 
                    :total="total" 
                    :modifiers="modifiers"
                    @next="() => { page++; load(); }" 
                    @prev="() => { page--; load(); }"
                    v-slot="{item}"
                    data-v-step-distribution-center="5">
                        <button class="button-edit" @click="edit(item)" title="Editar centro" :disabled="!$permission.hasAreaEditPermission('DistributionCenter')">
                            <i class="fa fa-fw fa-edit"></i>
                        </button>
                        <button class="button-remove" @click="remove(item.id)" title="Remover centro" :disabled="!$permission.hasAreaEditPermission('DistributionCenter')">
                            <i class="fa fa-fw fa-trash"></i>
                        </button>
                    </Table>
                </div>
            </div>
        </div>

        <DistributionCenterForm v-if="current" :current="current" />

        <Tour
            tour="DistributionCenter"
            :steps="tour_steps"
			:callbackOnFinish="true"
			ref="tour"
        />
    </div>
</template>

<script>
import Api from "@/lib/Api";

import Table from "@/components/Table";
import Tour from "@/components/Tour";
import DistributionCenterForm from './DistributionCenter/DistributionCenterForm';

export default {
    name: "DistributionCenter",

    components: {
        Table, 
        Tour,
        DistributionCenterForm,
    },

    data: function() {
        return {
            loading: false,
            search: "",
			headers: {
                name: "Nome",
                postal_code: "CEP",
                street: "Endereço",
                number: "Número",
                complement: "Complemento",
                neighborhood: "Bairro",
                city: "Cidade",
                uf: "UF",
            },
            ordering: ['name', "city", "uf"],
            order: 'name-ASC',
            list: [],
            page: 0,
            per_page: 20,
            total: 0,
            modifiers: {
                name: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
				postal_code: function(d) {
                    return d.replace(/^(\d{5})(\d{3})/, "$1-$2");
				},
				street: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
				number: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
				complement: function(d) {
					return `<span class="capitalized" title="${d}">${d ? d.toLowerCase() : '-'}</span>`;
				},
				neighborhood: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
				city: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
            },
            
            current: false,
            
            tour_steps: [
                {
                    target: '[data-v-step-distribution-center="0"]',
                    header: {
                        title: '<code>SEÇÃO CENTRO DE DISTRIBUIÇÃO</code>',
                    },
                    content: '<code>Clique no menu <b>CENTRO DE DISTRIBUIÇÃO</b> para ir a seção de listagem e gerenciamento dos centros de origem e distribuição das entregas</code>',
                    params: {
                        placement: 'right',
                        highlight: false,
                    }
                },
                {
                    target: '[data-v-step-distribution-center="1"]',
                    header: {
                        title: '<code>SEÇÃO ATUAL</code>',
                    },
                    content: '<code>Identifique pelo título a seção que está atualmente</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-distribution-center="2"]',
                    header: {
                        title: '<code>TOUR</code>',
                    },
                    content: '<code>Em caso de dúvida clique no botão <b>TOUR</b> para gerenciar a exibição do tour nessa seção, e assim ter um auxílio referente aos elementos da página</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-distribution-center="3"]',
                    header: {
                        title: '<code>ADICIONAR CENTRO DE DISTRIBUIÇÃO</code>',
                    },
                    content: '<code>Clique no botão <b>ADICIONAR</b> para abrir o formulário de cadastro manual de um novo centro de distribuição</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-distribution-center="4"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campo de filtragem da lista</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-distribution-center="5"]',
                    header: {
                        title: '<code>REGISTROS</code>',
                    },
                    content: '<code>Lista dos registros cadastrados</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ],
        }
    },

    beforeCreate: function() {
        if (!this.$permission.hasAreaPermission("DistributionCenter") || !this.$api.user.company_routing) {
            this.$router.push({ name: 'Home' });
        }
	},
    
    mounted: function() {
        this.$refs.tour.setTour();
        this.load();
    },
    
    activated: function() {
        this.load();
    },
    
    methods: {
        // Requisita a lista
		load: async function(is_search) {
            // Inicia o objeto das informações
            let form = {};
            
            // Verifica se houve uma busca
            if (this.search) form.search = this.search;
			if (is_search) this.page = 0;            
            form.page = this.page;
            form.per_page = this.per_page;
            
            // Verifica a ordenação
            if (this.order) form.order = this.order;
            
            // Reinicia as informações gerais
			this.list = [];
			this.total = 0;
            let result = null;
            
            // Requisita as informações
            this.loading = true;
            try {
                result = await Api.post("distribution-center/list", form);
            } catch (ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível obter a lista dos centros de distribuição.");
                return;
            }
            this.loading = false;
            
            if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.list = result.data;
					this.total = result.total;
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter a lista.");
				return;
			}
		},

        // Adiciona nova origem
        create: function() {
            this.current = "new";
        },
        
        // Editar origem
        edit: function(item) {
            this.current = item;
        },
        
        // Remove
        remove: async function(id) {
            // Apresenta a confirmação
            let confirm = await this.$alert.confirm("Deseja mesmo remover o centro de distribuição?", "REMOVER");

            // Verifica se para remover
            if(!confirm) return;
            
            // Iniciaas variáveis necessárias
            let form = {};
            form.id = id;
            let result = null;
            
            // Requisita a remoção
            this.loading = true;
            try {
                result = await Api.post("distribution-center/remove", form);
            } catch (ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível remover o centro de distribuição.");
                return;
            }
            this.loading = false;
            
            if(result) {
				// Verifica se houve erro
				if(result.error) {
                    if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
                        this.$notification.error(result.data);
                        return;
                    }
				} else {
					this.$notification.success("Centro de distribuição removido com sucesso.");

					// Recarrega a lista
					this.load();
					return;
				}
			} else {
				this.$notification.error("Não foi possível fazer a remoção.");
				return;
			}
        },
    }
}
</script>

<style scoped>
.add_new_origin {
	float: right;
	margin-top: 10px;
	border: none;
	background: #d9d9d9;
	color: #000;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
	margin-left: 15px;
}

.add_new_origin:disabled {
	cursor: not-allowed;
    opacity: .4;
}

.search {
	background: #fff;
	padding: 15px;
	border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
}

.search > label {
	font-weight: bold;
	font-size: 12px;
}

.search > input {
	width: 140px;
	margin-left: 15px;
}
</style>